export * from './src/gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
